module.exports = __webpack_public_path__ + "static/media/02_Launch.81a25ff6.svg";